<template>
  <div>
    <!--设置网址title-->
    <div v-wechat-title="$route.meta.title='理捷管理系统'"></div>
    <!--登录页背景图-->
    <div class="login_bg">
      <div class="login_title">
        <p>登录</p>
      </div>
      <div class="web_logo_bg">
        <img class="web_logo" src="../../static/logo.png" alt="">
        <p>理捷管理系统</p>
      </div>
      <div class="login_input_bg">
        <div class="login_input_box">
          <form>
            <!--账号-->
            <div class="login_acc_bg">
              <div class="login_acc_box">
                <!--登录icon-->
                <div class="ipt_icon account_icon"></div>
                <div class="login_input_w">
                  <input class="login_ipt" type="text" v-model="form.account" ref="account" placeholder="请输入登录账号">
                </div>
                <div class="ipt_icon2 clear_icon" v-show="form.account !== ''" @click="clearAccount()"></div>
              </div>
            </div>
            <!--密码-->
            <div class="login_acc_bg">
              <div class="login_acc_box">
                <!--登录icon-->
                <div class="ipt_icon psw_icon"></div>
                <div class="login_input_w">
                  <input class="login_ipt" type="password" v-model="form.psw" ref="account" placeholder="请输入登录密码">
                </div>
                <div class="ipt_icon2 clear_icon" v-show="form.psw !== ''" @click="clearPsw()"></div>
              </div>
            </div>
            <!--登录按钮-->
            <div class="login_acc_bg">
              <div class="login_acc_box login_btn_color">
                <input class="login_btn" type="button" value="登录" @click="login()">
              </div>
            </div>
          </form>
          <p class="support">技术支持 - @链讯科技</p>
        </div>
      </div>
    </div>
    <loading v-show="loading"></loading>
    <success v-show="success"></success>
  </div>
</template>

<style>

</style>

<script>
  import { webToast } from "@/assets/js/alertPopShow";
  import success from  '@/components/success'
  import loading from '@/components/loading'
  export default {
    name:'login',
    components:{
      loading,
      success
    },
    data(){
      return{
        form:{
          account:'',
          psw:'',
        },
//        初始化
        loading:false,
        success:false,
      }
    },
    created:function () {
      var that = this;
      //    配置微信jssdk
      var url = window.location.href.split('#')[0];
      that.app.wxjssdk(url);
    },
    methods:{
//      清空账号
      clearAccount(){
        var that = this;
        that.form.account = '';
      },
//      清空密码
      clearPsw(){
        var that = this;
        that.form.psw = '';
      },
//      登录
      login(){
        var that = this;
        var formData = new FormData();
        var account = that.form.account;
        var psw = that.form.psw;
        formData.append('username',account);
        formData.append('password',psw);
        if( account == ''){
          webToast('请输入登录账号','middle',1500);
          return false;
        }
        if( psw == '' ){
          webToast('请输入登录密码','middle',1500);
          return false;
        }else{
          that.loading = true;
          that.app.postData('/mhome.php/Login/loginAction',formData
            , result => {
              that.success = true;
              localStorage.setItem('token',result.content.token);
              localStorage.setItem('pos',result.content.permission_list);
              var jumpHome = setTimeout(function () {
                that.success = false;
                that.$router.push({path:'/'});
              },1000)
            },()=>{
              that.loading = false;
            })
        }
      }
    },
    beforeRouteEnter(to,from,next){
      if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
        if (to.path !== location.pathname) {
          // 此处不可使用location.replace
          location.assign(to.fullPath)
        } else {
          next()
        }
      }else{
        next();
      }
    },
    beforeRouteLeave(to,from,next){
      window.document.body.style.background = '';
      next();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/login.vue